import { ProspectsActionKeys as keys } from './prospectsActionKeys';
import * as types from './prospectsActionTypes';
import { ChangeProspectDirection, INewProspectRequest, IProspect, IProspectApiResponse } from './prospectsInterfaces';

export const prospectActionCreators = {
  activate: (prospectId: number): types.ActivateProspect => ({
    payload: { prospectId },
    type: keys.ACTIVATE_PROSPECT
  }),
  changeProspectState: (id: number, direction: ChangeProspectDirection): types.ChangeLifecycleStep => ({
    payload: { direction, id },
    type: keys.CHANGE_LIFECYCLE_STEP
  }),
  changeProspectStateFulfilled: (id: number, newStateId: number): types.ChangeLifecycleStepFulfilled => ({
    payload: { id, newStateId },
    type: keys.CHANGE_LIFECYCLE_STEP_FULFILLED
  }),
  createProspect: (payload: INewProspectRequest): types.CreateProspect => ({
    payload,
    type: keys.CREATE_PROSPECT
  }),
  deactivate: (payload: { prospectId: number; reason: string }): types.DeactivateProspect => ({
    payload,
    type: keys.DEACTIVATE_PROSPECT
  }),
  fetchProspect: (payload: { prospectId?: number; businessEntityId?: number }): types.FetchProspect => ({
    payload,
    type: keys.FETCH_PROSPECT
  }),
  fetchProspects: (payload: { skip: number }): types.FetchProspects => ({
    payload,
    type: keys.FETCH_PROSPECTS
  }),
  freeze: (payload: { prospectId: number; thawDate: Date }): types.FreezeProspect => ({
    payload,
    type: keys.FREEZE_PROSPECT
  }),
  hideLoading: (): types.HideProspectsLoading => ({ type: keys.HIDE_PROSPECTS_LOADING }),
  saveComplete: (prospectId: number): types.SaveComplete => ({ payload: { prospectId }, type: keys.SAVE_COMPLETE }),
  setProspects: (payload: IProspectApiResponse[]) => ({
    payload,
    type: keys.SET_PROSPECTS
  }),
  setTotalItems: (payload: {
    prospectStatusId: number;
    totalItems: { [index: string]: number };
  }): types.SetProspectTotalItems => ({
    payload,
    type: keys.SET_PROSPECT_TOTAL_ITEMS
  }),
  showLoading: (): types.ShowProspectsLoading => ({ type: keys.SHOW_PROSPECTS_LOADING }),
  thaw: (prospectId: number): types.ThawProspect => ({
    payload: { prospectId },
    type: keys.THAW_PROSPECT
  }),
  updateProspect: (prospect: IProspect): types.UpdateProspect => ({
    payload: prospect,
    type: keys.UPDATE_PROSPECT
  }),
  updateProspectFulfilled: (prospect: IProspectApiResponse): types.UpdateProspectFulfilled => ({
    payload: prospect,
    type: keys.UPDATE_PROSPECT_FULFILLED
  })
};
